export function createRide({ payload }) {
  return {
    url: `/api/rides`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function deleteRide({ payload }) {
  return {
    url: `/api/rides/${payload.id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function rides(params) {
  const formatParams = (data) => {
    return Object.keys(data)
      .filter((key) => {
        if (['startDate', 'endDate'].includes(key)) {
          return typeof data[key] !== 'undefined'
        }

        return !!data[key]
      })
      .map((key) => {
        if (['t1', 't2', 't3'].includes(key)) {
          return `vehicleType[]=${key}`
        }
        if (['single', 'recurrent', 'glinko%20delivery', 'glinko%20loading'].includes(key)) {
          return `rideTypeFilter[]=${key}`
        }
        if (['itemsPerPage', 'page'].includes(key)) {
          return `${key}=${data[key]}`
        }
        if (['startDate'].includes(key)) {
          const date = new Date(data[key])
          return `startDate=${date
            .toLocaleDateString()
            .replace('/', '-')
            .replace('/', '-')}`
        }
        if (['endDate'].includes(key)) {
          const date = new Date(data[key])
          return `endDate=${date
            .toLocaleDateString()
            .replace('/', '-')
            .replace('/', '-')}`
        }
      })
      .join('&')
  }
  const formattedParams = !params ? '' : formatParams(params)
  return {
    url: `/api/rides?${formattedParams}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function modify({ params, payload }) {
  return {
    url: `/api/rides/${params.id}`,
    method: 'PATCH',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/merge-patch+json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}
